"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelToSnakeCaseObject = exports.camelToSnakeCaseWithUnderscoreOnInitialDigit = exports.camelToSnakeCase = exports.toNullableObject = exports.snakeToCamelCaseObjectWithUnderscoreOnInitialDigit = exports.snakeToCamelCaseObject = exports.snakeToCamelCaseWithUnderscoreOnInitialDigit = exports.snakeToCamelCase = exports.toOptionalObjectExcept = exports.toOptionalObject = exports.isOption = void 0;
const O = __importStar(require("fp-ts/Option"));
const function_1 = require("fp-ts/function");
const isOption = (val) => typeof val === 'object' && !!val && '_tag' in val && (val._tag === 'None' || (val._tag === 'Some' && 'value' in val));
exports.isOption = isOption;
const toOptionalObject = (obj) => Object.entries(obj).reduce((p, [key, val]) => ({ ...p, [key]: O.fromNullable(val) }), {});
exports.toOptionalObject = toOptionalObject;
const toOptionalObjectExcept = (obj, except) => Object.entries(obj).reduce((p, [key, val]) => ({
    ...p,
    [key]: except.includes(key) ? val : O.fromNullable(val),
}), {});
exports.toOptionalObjectExcept = toOptionalObjectExcept;
const snakeToCamelCase = (s) => s
    .replace(/([_-][\da-z])/g, (match) => match.toUpperCase().replace(/[_-]/g, ''))
    .replace(/\d+/g, (match) => match.charAt(0).toUpperCase() + match.slice(1));
exports.snakeToCamelCase = snakeToCamelCase;
const underscoreOnInitialDigit = (s) => s.replace(/^(\d)/, '_$1');
const snakeToCamelCaseWithUnderscoreOnInitialDigit = (s) => (0, function_1.pipe)(s, exports.snakeToCamelCase, underscoreOnInitialDigit);
exports.snakeToCamelCaseWithUnderscoreOnInitialDigit = snakeToCamelCaseWithUnderscoreOnInitialDigit;
const snakeToCamelCaseObject = (obj) => Object.entries(obj).reduce((p, [key, val]) => ({ ...p, [(0, exports.snakeToCamelCase)(key)]: val }), {});
exports.snakeToCamelCaseObject = snakeToCamelCaseObject;
const snakeToCamelCaseObjectWithUnderscoreOnInitialDigit = (obj) => Object.entries(obj).reduce((p, [key, val]) => ({ ...p, [(0, exports.snakeToCamelCaseWithUnderscoreOnInitialDigit)(key)]: val }), {});
exports.snakeToCamelCaseObjectWithUnderscoreOnInitialDigit = snakeToCamelCaseObjectWithUnderscoreOnInitialDigit;
const toNullableObject = (obj) => Object.entries(obj).reduce((p, [key, val]) => ({
    ...p,
    [key]: (0, exports.isOption)(val) ? O.toNullable(val) : val,
}), {});
exports.toNullableObject = toNullableObject;
const camelToSnakeCase = (str) => str
    .replace(/([a-z])(\d+)|([A-Z])/g, (match, p1, p2, p3) => (p2 ? `${p1}_${p2}` : `_${p3.toLowerCase()}`))
    .replace(/^_/, '');
exports.camelToSnakeCase = camelToSnakeCase;
const camelToSnakeCaseWithUnderscoreOnInitialDigit = (s) => (0, function_1.pipe)(s, exports.camelToSnakeCase, underscoreOnInitialDigit);
exports.camelToSnakeCaseWithUnderscoreOnInitialDigit = camelToSnakeCaseWithUnderscoreOnInitialDigit;
const camelToSnakeCaseObject = (obj) => {
    return Object.entries(obj).reduce((p, [key, val]) => ({
        ...p,
        [(0, exports.camelToSnakeCase)(key)]: val,
    }), {});
};
exports.camelToSnakeCaseObject = camelToSnakeCaseObject;
